import type { Person } from '@features/person/models/person.model';

const BASE: Person = {
  personId: 'person-123',
  firstName: 'John',
  lastName: 'Doe',
  email: 'john.doe@example.com',
  phone: '+421900123456',
  birthday: '1990-01-01',
  termsAcceptanceTime: '2026-01-15T10:00:00.000Z',
  privacyConsentTime: '2026-01-15T10:01:00.000Z'
};

export const PERSON_SCENARIOS = {
  /** TC-1.1: Terms and telemedicine consent both accepted — no consent modal on reopen */
  TC_1_1: { ...BASE } satisfies Person,

  /** TC-1.2: First-time user who closed the app on the consent modal — privacy policy modal on reopen */
  TC_1_2: { ...BASE, termsAcceptanceTime: null, privacyConsentTime: null } satisfies Person,

  /** TC-1.3: Terms accepted, telemedicine consent missing or revoked — consent modal on reopen */
  TC_1_3: { ...BASE, privacyConsentTime: null } satisfies Person
} satisfies Record<string, Person>;
